import React, { useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Chip } from "@mui/material";
import { Button, Form, Table, Modal } from "react-bootstrap";

import { BASE_URL } from "../../api/api";

const CompletedBatches = () => {
    const [batchData, setBatchData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

    // Fetch payment history on mount
    useEffect(() => {
        const fetchPaymentHistory = async () => {
            try {
                const res = await fetch(`${BASE_URL}/GetPaymentHistory`);
                const data = await res.json();
                console.log(data, 'ookkkkkkk')
                if (Array.isArray(data.dataList)) {
                    setBatchData(data.dataList);
                }
                else {
                    console.error("Unexpected response format:", data);
                }
            } catch (error) {
                console.error("Error fetching payment history:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPaymentHistory();
    }, []);
    const sortedData = [...batchData].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = a[sortConfig.key] ?? "";
        const valB = b[sortConfig.key] ?? "";

        if (typeof valA === "number" && typeof valB === "number") {
            return sortConfig.direction === "asc" ? valA - valB : valB - valA;
        }

        return sortConfig.direction === "asc"
            ? String(valA).localeCompare(String(valB))
            : String(valB).localeCompare(String(valA));
    });
    const handleSort = (key) => {
        setSortConfig((prev) => {
            const isSameKey = prev.key === key;
            return {
                key,
                direction: isSameKey && prev.direction === "asc" ? "desc" : "asc",
            };
        });
    };

    const handleRowClick = (row) => {
        console.log("Row clicked:", row);
        // Optionally navigate to another page or open modal
    };

    console.log(batchData, 'JDJDFJDJFJDFJ')
    return (
        <div className="mt-4 px-3">

            <h4 className="mb-3">Completed Batches</h4>
            <div className="table-responsive mt-3">
                <div className="netwrok_table_main_content">
                    <div className="table-container mt-3">
                        <Table className="bg-white text-center border-0 network_table">
                            <thead className="table-light" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                                <tr className="text-dark fw-semibold table_th_border text-nowrap">
                                    <th onClick={() => handleSort("scheduleId")} style={{ cursor: "pointer" }}>
                                        Schedule ID {sortConfig.key === "scheduleId" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>

                                    <th onClick={() => handleSort("batchNo")} style={{ cursor: "pointer" }}>
                                        Batch No {sortConfig.key === "batchNo" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("invoiceNo")} style={{ cursor: "pointer" }}>
                                        Invoice No {sortConfig.key === "invoiceNo" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("paidTotalServiceCharges")} style={{ cursor: "pointer" }}>
                                        Paid Service Charges {sortConfig.key === "paidTotalServiceCharges" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("paidRepairCharges")} style={{ cursor: "pointer" }}>
                                        Paid Repair Charges {sortConfig.key === "paidRepairCharges" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("paidGst")} style={{ cursor: "pointer" }}>
                                        Paid GST {sortConfig.key === "paidGst" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("paidFinalAmount")} style={{ cursor: "pointer" }}>
                                        Paid Final Amount {sortConfig.key === "paidFinalAmount" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("remainingServiceCharges")} style={{ cursor: "pointer" }}>
                                        Remaining Service Charges {sortConfig.key === "remainingServiceCharges" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("remainingRepairCharges")} style={{ cursor: "pointer" }}>
                                        Remaining Repair Charges {sortConfig.key === "remainingRepairCharges" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("remainingGst")} style={{ cursor: "pointer" }}>
                                        Remaining GST {sortConfig.key === "remainingGst" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("remainingFinalAmount")} style={{ cursor: "pointer" }}>
                                        Remaining Final Amount {sortConfig.key === "remainingFinalAmount" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("caseCount")} style={{ cursor: "pointer" }}>
                                        Case Count {sortConfig.key === "caseCount" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th onClick={() => handleSort("vendorName")} style={{ cursor: "pointer" }}>
                                        Vendor Name {sortConfig.key === "vendorName" ? (sortConfig.direction === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading && (
                                    <tr>
                                        <td colSpan="19" className="text-center py-3">
                                            Validating data...
                                        </td>
                                    </tr>
                                )}
                                {!loading &&
                                    sortedData.map((invoice, index) => (
                                        <tr
                                            key={
                                                invoice.scheduleId || `${invoice.scheduleId}-${index}`
                                            }
                                            className={`text-center border-bottom network_td_item`}
                                        >
                                            <td className="align-middle">
                                                {invoice.scheduleId || "-"}
                                            </td>
                                            <td className="align-middle">
                                                {invoice.batchNo || "-"}
                                            </td>
                                            {/* <td className="align-middle">
                                        {new Date().toLocaleDateString("en-GB")}
                                    </td> */}
                                            <td className="align-middle">
                                                {invoice.invoiceNo || "-"}
                                            </td>
                                            <td className="align-middle">
                                                {invoice.paidTotalServiceCharges || "-"}
                                            </td>
                                            <td className="align-middle">{invoice.paidTotalRepairCharges || "-"}</td>
                                            <td className="align-middle">
                                                {invoice.paidGST || "-"}
                                            </td>
                                            <td className="align-middle">
                                                {invoice.paidFinalAmount || "0.00"}
                                            </td>
                                            <td className="align-middle">
                                                {invoice.remainingTotalServiceCharges || "0.00"}
                                            </td>
                                            <td className="align-middle">
                                                {invoice.remainingTotalRepairCharges || "0.00"}
                                            </td>
                                            <td className="align-middle">
                                                <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                                                    {invoice.remainingGST || "-"}
                                                </span>
                                            </td>
                                            <td className="align-middle">
                                                <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                                                    {invoice.remainingFinalAmount || "-"}
                                                </span>
                                            </td>
                                            <td className="align-middle">
                                                <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                                                    {invoice.caseCount || "-"}
                                                </span>
                                            </td>
                                            <td className="align-middle">
                                                <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                                                    {invoice.vendorName || "-"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompletedBatches;
